import { creategetRequest, createPostRequest } from './request';
import { URL_DB_GET_USER } from '../../constants';

const url = 'api/';

export const getUserDataFromDB = () => {
  return creategetRequest(url + URL_DB_GET_USER)
    .then((res) => res.data)
    .catch((err) => err);
};

export const updateUserData = (data) => {
  return createPostRequest(`/api/data/updateUser`, data);
};
